import * as React from 'react';
import * as intl from 'react-intl-universal';
import { Modal, Alert } from 'antd';
import Button from 'common/components/Button';
import { type iOption, type modalId } from './types';

interface iProps {
    id: modalId;
    config: iOption;
    onTrigger: Function;
}

export default class Dialog extends React.Component<iProps> {
    state = {
        locker: false,
    };

    componentDidMount(): void {
        if (Object.prototype.hasOwnProperty.call(this.props.config, 'locker')) {
            this.setState({ locker: this.props.config.locker });
        }
    }

    /**
     * 通过modalHelper关闭
     */
    closeModal = () => {
        const { id, onTrigger } = this.props;
        onTrigger('closeModal', id);
    };

    /**
     * 通过外部方法关闭
     */
    closeClickHandler = () => {
        const { onCancel } = this.props.config;
        onCancel && onCancel();
        this.closeModal();
    };

    /**
     * 外部方法确定
     */
    okClickHandler = () => {
        const { onOK, auto = '0' } = this.props.config;
        if (onOK) {
            onOK((isLoading: boolean) => this.setState({ locker: isLoading }));
        }
        auto == '0' && this.closeModal();
    };

    // todo: 获取自定义footer
    getFooter = (footer: any, okText?: string, cancelText?: string) => {
        switch (footer) {
            case 'close':
                return (
                    <p style={{ textAlign: 'right' }}>
                        <Button type="primary" size="large" onClick={this.closeClickHandler}>
                            {cancelText || intl.get('Global.Close')}
                        </Button>
                    </p>
                );
            case 'all':
                return (
                    <div>
                        <Button size="large" onClick={this.closeClickHandler}>
                            {cancelText || intl.get('Global.Close')}
                        </Button>
                        <Button type="primary" size="large" onClick={this.okClickHandler}>
                            {okText || intl.get('Global.Submit')}
                        </Button>
                    </div>
                );
            case 'submit':
                return (
                    <div>
                        <Button type="primary" size="large" onClick={this.okClickHandler}>
                            {okText || intl.get('Global.Submit')}
                        </Button>
                    </div>
                );
            default:
                return footer;
        }
    };

    render() {
        const { config } = this.props;
        const { title, okText, cancelText, content, style, bodyStyle, centered, width, alert, wrapClassName, footer } =
            config;
        const { locker: lockerStatus } = this.state;
        return (
            <Modal
                title={title}
                onOk={this.okClickHandler}
                onCancel={this.closeClickHandler}
                confirmLoading={lockerStatus}
                style={style}
                bodyStyle={bodyStyle}
                centered={centered}
                width={width}
                wrapClassName={wrapClassName}
                okText={okText}
                footer={this.getFooter(footer, okText, cancelText)}
                cancelText={cancelText}
                visible={true}
                maskClosable={false}
            >
                {alert && <Alert message={alert} showIcon />}
                {content}
            </Modal>
        );
    }
}
